// Generated by Melange

import * as Buhta_components__Text from "../../../../packages/components/src/html/Text.js";
import * as Buhta_conf__Config from "../../../../packages/conf/lib/Config.js";
import * as JsxRuntime from "react/jsx-runtime";

function AuthTemplate(Props) {
  let children = Props.children;
  const cfg = Buhta_conf__Config.getConfig(undefined);
  const env = cfg.app_env;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("a", {
            children: JsxRuntime.jsx("svg", {
              children: JsxRuntime.jsx("path", {
                clipRule: "evenodd",
                d: "M35.647 20.5197L29.127 8.91802H23.4553L33.1708 25.4482L29.8787 31.9996H34.9634L46.4711 8.91802H40.965L35.647 20.5197ZM72.4316 8.91802H66.6609L61.7809 16.4031L56.9337 8.91802H50.9982L58.7145 20.2606L50.6688 32H56.4391L61.6494 24.0857L66.8261 32H72.7615L64.7153 20.1949L72.4316 8.91802ZM78.0982 13.6001H85.1215V31.9996H90.1992V13.6001H97.2233V8.91802H78.0982V13.6001ZM10.6915 27.4126H5.08198V21.737H10.6586C13.0675 21.737 14.2223 22.6942 14.2223 24.4762C14.2223 26.4887 13.0675 27.4126 10.6915 27.4126ZM11.1861 17.514H5.08198V13.4882H18.0348V8.90159H0.000391313V31.9992H10.6915C16.0368 31.9992 19.3039 29.3927 19.3039 24.6742C19.3039 20.3514 16.4003 17.514 11.1861 17.514ZM0 4.58658H18.0352V0H0V4.58658ZM109.19 22.3381L112.257 14.8535L115.323 22.3381H109.19ZM114.664 8.75289H109.982L100.089 31.9996H105.266L107.377 26.8229H117.137L119.247 31.9996H124.556L114.664 8.75289Z",
                fill: "white",
                fillRule: "evenodd"
              }),
              className: "inline-block",
              height: "32",
              width: "125",
              fill: "none",
              viewBox: "0 0 125 32",
              xmlns: "http://www.w3.org/2000/svg"
            }),
            href: env === "production" ? "https://buhta.com" : "https://sandbox.buhta.com"
          }),
          className: "flex justify-center mb-14"
        }),
        children,
        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
          className: "mt-12 text-center text-white",
          children: "© 2014-2024 ТОО \"Бухта\""
        })
      ],
      className: "w-112 py-14 flex flex-col"
    }),
    className: "bg-black h-screen font-hauss flex justify-center overflow-auto px-4 lg:px-0"
  });
}

const make = AuthTemplate;

export {
  make,
}
/* Buhta_components__Text Not a pure module */
